export default __webpack_public_path__ + "static/media/wave5.5fa0621e.svg";